import { ChakraFlex } from '@equip.health/ui';

import MaiChatThinking from './MaiChatThinking';
import MaudMark from './MaudMark';

// Shown between send and the first frame, before the AI bubble appears.
const MaiChatTypingIndicator = () => (
  <ChakraFlex
    data-testid="mai-chat-typing-indicator"
    alignItems="flex-start"
    gap="10px"
    maxWidth="92%"
  >
    <MaudMark size={22} />
    <MaiChatThinking />
  </ChakraFlex>
);

export default MaiChatTypingIndicator;
